import {
    Chart,
    ArcElement,
    BarElement,
    BarController,
    LineController,
    CategoryScale,
    PieController,
    LinearScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip,
    SubTitle
 } from 'chart.js';

const vAdminChart = () => {
    Chart.register(
        ArcElement,
        BarElement,
        BarController,
        LineController,
        CategoryScale,
        PieController,
        LinearScale,
        Decimation,
        Filler,
        Legend,
        Title,
        Tooltip,
        SubTitle
    );

    const ctx = document.querySelectorAll('.myChart');
    const mqSmall = window.matchMedia('(max-width: 1024px)');
    let colorsCalled = 0;
    let dashChart;
    let dashChartArr = [];

    const colorsEven = ['rgb(0, 167, 202)','rgb(27, 150, 183)','rgb(38, 134, 164)','rgb(43, 117, 145)','rgb(44, 102, 125)','rgb(44, 87, 107)','rgb(42, 72, 88)','rgb(0, 167, 202)','rgb(27, 150, 183)','rgb(38, 134, 164)','rgb(43, 117, 145)','rgb(44, 102, 125)','rgb(44, 87, 107)','rgb(42, 72, 88)']
    const colorsOdd = ['rgb(229, 198, 70)','rgb(233, 206, 99)','rgb(236, 214, 126)','rgb(240, 222, 152)','rgb(243, 230, 178)','rgb(246, 237, 203)','rgb(249, 245, 229)','rgb(229, 198, 70)','rgb(233, 206, 99)','rgb(236, 214, 126)','rgb(240, 222, 152)','rgb(243, 230, 178)','rgb(246, 237, 203)','rgb(249, 245, 229)']

    const setColors = (count) => {
        const colors = [];
        for (let i = 0; i < count; i++) {
            if (colorsCalled % 3 === 0) {
                colors.push(colorsEven[i]);
            } else {
                colors.push(colorsOdd[i]);
            }

        }

        (colorsCalled > 2) ? colorsCalled = 0 : colorsCalled++;
        return colors;
    }

    let charts = [...ctx].forEach(chart => {
        let data = {
          labels: chart.dataset.labels.split(','),
          datasets: [
            {
              label: `Dataset ${colorsCalled}`,
              data: chart.dataset.totals.split(',').map(num => {
                  // trying to add a percent (`${num}%`), but not working
                  return num;
              }),
              backgroundColor: setColors(chart.dataset.totals.split(',').length),
            }
          ]
        };

        dashChart = new Chart(chart, {
            type: chart.dataset.type,
            data: data,
            options: {
              responsive: mqSmall.matches ? false : true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                    display: chart.dataset.type === 'bar' ? false : true,
                    position: 'bottom',
                    align: 'start',
                    labels: {
                        boxWidth: 30,
                        boxHeight: 30,
                        padding: 20,
                    }
                },
                title: {
                  display: false,
                  padding: 0,
                }
              }
            },
        });

        dashChartArr.push(dashChart);
    });

    window.addEventListener( 'resize', () => {
        // should debounce this
        if ( mqSmall.matches ) {
            [...dashChartArr].forEach(chart => {
                chart.options.responsive = false;
                chart.update();
            });
        } else {
            // should debounce this
            [...dashChartArr].forEach(chart => {
                chart.options.responsive = true;
                chart.update();
            });
        }
    });
}

export default vAdminChart;
